// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/square-dashed-mouse-pointer.js';

import { paths } from '../generated/square-dashed-mouse-pointer';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('square-dashed-mouse-pointer', Original, paths);
